(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    // Delegated from the document, like the header's listeners: block scripts run
  // once per block type, not once per instance, so binding per element here
  // would attach the same handler several times over.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-scroll-next');

    if (!trigger) return;

    // Skip past anything an app may have injected between the two sections.
    let next = trigger.closest('.shopify-section')?.nextElementSibling;

    while (next && !next.classList.contains('shopify-section')) {
      next = next.nextElementSibling;
    }

    if (!next) return;

    // The CSS honours prefers-reduced-motion, but scrollIntoView's own
    // `behavior` overrides it, so the preference has to be read again here.
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    next.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
